/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PairMobileDeviceRequest
 */
export interface PairMobileDeviceRequest {
    /**
     * The nonce decoded from the scanned QR code.
     * @type {string}
     * @memberof PairMobileDeviceRequest
     */
    nonce: string;
    /**
     * Optional user-facing device name to show in the customer's device list.
     * @type {string}
     * @memberof PairMobileDeviceRequest
     */
    deviceName?: string;
}

/**
 * Check if a given object implements the PairMobileDeviceRequest interface.
 */
export function instanceOfPairMobileDeviceRequest(value: object): value is PairMobileDeviceRequest {
    if (!('nonce' in value) || value['nonce'] === undefined) return false;
    return true;
}

export function PairMobileDeviceRequestFromJSON(json: any): PairMobileDeviceRequest {
    return PairMobileDeviceRequestFromJSONTyped(json, false);
}

export function PairMobileDeviceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PairMobileDeviceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'nonce': json['nonce'],
        'deviceName': json['deviceName'] == null ? undefined : json['deviceName'],
    };
}

  export function PairMobileDeviceRequestToJSON(json: any): PairMobileDeviceRequest {
      return PairMobileDeviceRequestToJSONTyped(json, false);
  }

  export function PairMobileDeviceRequestToJSONTyped(value?: PairMobileDeviceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nonce': value['nonce'],
        'deviceName': value['deviceName'],
    };
}

